export default {
  route: {
    routeHome: '首页',
    routeVehicle: '车辆信息',
    routeRepair: '维修信息',
    routeTechnical: '技术文件',
    routeSystemOverview: '系统概述',
    routeMaintenance: '维修保养',
    routeCircuit: '电路图',
    routeSearchParts: '配件查询',
    routePartsAdvice: '问题咨询',
    routePartsAdviceDetails: '问题咨询详情',
    routePartsAdviceList: '问题咨询管理列表',
    routeResolvedManagement: '已解决问题列表',
    routeFeedBack: '问题资料反馈',
    routeSysProFeedBack: '反馈列表',
    routeMaintainFeedBack: '维修案例反馈',
    routeSysFeedBack: '反馈管理列表',
    routeCart: '购物车',
    routeIccId: 'ICCID查询',
    routeKeyQuery: '钥匙码查询',
    routeQueryStatistics: '查询统计',
    routeOrder: '我的订单',
    routeSysUser: '用户管理',
    routeSysRole: '角色管理',
    routeSysMenu: '菜单权限管理',
    routeSysEnterprise: '企业信息管理',
    routeSysChange: '变更管理',
    routeSystem: '系统管理',
    routeInfo: '信息反馈',
    operation: '随车手册',
    userManual: '用户手册',
    maintenance: '保养保修',
    disassembly: '拆解手册',
    version: '诊断软件版本',
    emergency: '应急救援',
    routeItp: 'ITP-智能技术信息平台',
    routeReleaseManagement: '数据发布管理',
    routePublicAnnouncement: '资料公告',
    routeKnowledge: '知识库',
    routeMarketDisposal: '市场处置',
    routeTechnicalCircular: '技术通告',
    routeVehBom: '一车一BOM',
    routeVehCar: '车型配置表',
    routeSpareParts: '备件拆分回函库',
    routeCriticalParts: '质量关键件',
    routeLoginManagement: '登录信息管理',
    routeLoadBom: '装车BOM',
    routeVehicleNavigation: '车型导航管理',
    routeOverseasData: '海外数据权限管理',
    routeLanguage: '动态翻译库管理',
    routeOverseas: '海外管理',
    routeSubscriptionRightsManagement: '订阅权限管理',
    routeSparePartsAnnouncement: '备件公告',
    routeFeedbackOnQualityIssues: '技术质量问题反馈',
    routeFeedbackOnQualityIssuesList: '技术质量问题反馈管理列表',
    routeFeedbackOnQualityIssuesDetails: '技术质量问题反馈详情',
    routeTechnicalSupport: '技术支持',
    routeSysMember: '会员管理',
    routeGeneralInfo: '通用信息',
    routeRepairGeneralInfo: '维修公开平台通用信息',
    routeRepairInfo: '维修信息公开',
    routeRepairInfoConsulting: '维修信息公开咨询',
    routeRepairInfoConsultingList: '维修信息公开咨询管理列表',
    routeRepairInfoConsultingDetails: '维修信息公开咨询详情',
    routeRepairPlatform: '维修公开平台管理'
  },
  documentTypes: {
    wis: '维修手册',
    circuit_diagram: '电路图',
    overview: '系统概述',
    maintenance: '保修保养',
    c3d_atlas: '配件图册',
    user_manual: '用户手册',
    warranty_manual: '保养手册'
  },
  common: {
    commonDelete: '删除',
    commonCancel: '取消',
    commonConfirm: '确定',
    commonSearch: '查询',
    commonUpload: '上传',
    commonClose: '关闭',
    commonPreserve: '保存',
    commonDelTips: '删除提示',
    commonTips: '您确定要删除',
    commonCopy: '复制VIN',
    common1: '启用',
    common2: '禁用',
    common3: '锁定',
    common4: '暂无数据',
    common5: '发布',
    common6: '撤销发布',
    common7: '修改',
    common8: '更多搜索',
    common9: '新增',
    common10: '另存为',
    common11: '提交',
    common12: '发布到'
  },
  searchHome: {
    vehicle: '车型导航',
    parts: '配件',
    tips: '请选择',
    tips2: '请输入',
    tips3: '请输入17位VIN码',
    tips4: '请输入配件名称或配件编码',
    time: '最近登录时间',
    notice: '公告',
    more: '更多',
    market: '市场处置',
    update: '资料更新',
    maintenance: '维修案例',
    access: '访问历史',
    accessory: '问题咨询',
    part1: '配件图号',
    part2: '配件名称',
    part3: '系统',
    part4: '供应商编码',
    part5: '供应商名称',
    part6: '整车物料',
    part7: '生产日期',
    part8: '件号',
    part9: '层级关系',
    part10: '用户名称',
    part11: '登录时间'
  },
  login: {
    title: '欢迎登录',
    logIn: '登录',
    logOut: '退出登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    userLogIn: '用户名密码',
    mobileLogIn: 'LDAP',
    cepLogin: '销服账号登录',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },

  table: {
    model: '车型',
    faulty: '故障系统',
    theme: '主题',
    date: '时间',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    id: '序号',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    reset: '重置',
    delete: '删除',
    refresh: '刷新'

  },
  cart: {
    viewOrder: '查看订单',
    generateOrder: '生成订单',
    sendOrder: '发送订单',
    partCode: '配件编码',
    partName: '配件名称',
    pcsOrder: '订货量',
    minimum: '最小包装数',
    shoppingNum: '购物车清单单号',
    orderDate: '订单日期',
    startDate: '开始日期',
    endDate: '结束日期',
    startTime: '起始时间',
    endTime: '结束时间'
  },
  maintainFeedBack: {
    myFeedback: '我的反馈',
    downloadTemplate: '下载模板',
    feedbackManage: '反馈管理列表'
  },
  maintainFeedBackFaultEnum: {
    0: '高压蓄电池系统',
    1: '电机和电气控制系统',
    2: '底盘系统',
    3: '内外饰系统',
    4: '车身系统',
    5: '车辆电子系统',
    6: '辅助系统'
  },
  partsAdvice: {
    hide: '隐藏',
    show: '显示',
    question: '我的提问',
    askQuestion: '我要提问',
    partsManagement: '问题咨询管理列表',
    feedbackOnQualityIssuesManagement: '技术质量问题反馈管理列表',
    resolvedManagement: '已解决问题列表',
    myProblem: '我的问题',
    storeName: '门店名称',
    enterpriseName: '企业名称',
    storeCode: '门店代码',
    enterpriseCode: '企业代码',
    station: '岗位',
    name: '姓名',
    userName: '用户名',
    problemType: '问题类型',
    problemDes: '问题描述',
    problemStatus: '问题状态',
    date: '日期',
    submitTime: '提交时间',
    storeInfo: '门店信息',
    modelInfo: '车型信息',
    consultQuestion: '咨询问题',
    resolve: '已解决的原因',
    setResolved: '设为已解决',
    resolvedReason: '确定设为该问题已解决 ?',
    tips: '提示',
    answer: '回答记录',
    questionReply: '问题回复',
    reply: '回复',
    replyTime: '回复时间',
    respondent: '回复人',
    issueLevel: '问题等级',
    responseTime: '响应时间',
    questioner: '提问人',
    faultMileage: '故障里程数',
    salesDate: '销售日期',
    faultyPartNumber: '故障零件号',
    frequencyOfFailures: '故障发生频次',
    troubleshootingAnalysis: '故障排查分析',
    messageDes: '信息描述'
  },
  repair: {
    state: '发布状态',
    model: '车型',
    year: '年款',
    config: '配置',
    mileage: '里程',
    powerBattery: '电池',
    faultLocation: '故障系统',
    faultyPart: '故障零件',
    submitter: '故障技师',
    contactPhone: '联系电话',
    eMailAddress: '邮箱地址',
    subject: '故障主题',
    enterpriseName: '零跑服务中心店',
    dtcInfo: '故障DTC信息',
    controller: '控制器',
    faultDesc: '故障描述',
    language: '语言',
    repair1: '审核人',
    repair2: '审核时间',
    repair3: '审核意见',
    repair4: '审核状态',
    repair5: '积分',
    repair6: '审核',
    redPartWarning: '请勿订购红色配件号，联系工程老师'
  },
  problemFeedBack: {
    classify: '问题分类',
    systematic: '所属系统'
  },
  system: {
    userType: '用户类型',
    roleName: '角色名称',
    state: '状态',
    keyWord: '全部',
    searchValue: '请输入关键字查询',
    settingRole: '角色权限设置'
  },
  keyQuery: {
    queryStatistics: '查询统计',
    searchUsers: '搜索用户',
    repair: '维修中心',
    queryTime: '查询时间',
    vinCode: 'VIN码',
    keyCode: '配钥匙码'
  },
  routeVehicle: {
    materialCode: '物料编码',
    logisticsDes: '物料描述',
    vehicleSeries: '基本车系',
    basicModel: '基本车型',
    basicYear: '基本年款',
    range: '续航里程',
    optionalPower: '选配动力',
    hub: '轮毂',
    exterior: '外饰风格',
    roof: '车顶风格',
    interior: '内饰风格',
    package: '选装包',
    battery: '电池电芯',
    vehicle1: '车辆年型',
    vehicle2: '选配续航',
    vehicle3: '选配轮毂',
    vehicle4: '车牌号',
    vehicle5: '车辆属性',
    vehicle6: '公告车型',
    vehicle7: '发动机号',
    vehicle8: '车型',
    vehicle9: '电池型号',
    vehicle10: '电池序列号',
    vehicle11: '发动机型号',
    vehicle12: '电机序列号',
    vehicle13: '合格证号',
    vehicle14: '电机型号',
    vehicle15: '车辆产地',
    vehicle16: '车辆名称',
    vehicle17: '电驱序列号(前)',
    vehicle18: '电驱序列号(后)',
    vehicle19: '车辆通用名称',
    vehicle20: '制造工厂',
    vehicle21: '车辆品牌',
    vehicle22: '车身颜色',
    vehicle23: '车辆生产企业名称',
    vehicle24: '车辆类型',
    vehicle25: '燃料种类',
    vehicle26: '车辆销售变更时间',
    vehicle27: '制造日期',
    vehicle28: 'VDC入库日期',
    vehicle29: '车辆出厂时间',
    vehicle30: '销售日期',
    vehicle31: '实名状态',
    vehicle32: '受理时间',
    vehicle33: '车辆配置表',
    vehicle34: '版型名称',
    vehicle35: '说明',
    vehicle36: '车型配置',
    vehicle37: '原始文件名',
    vehicle38: '高级搜索'
  },
  routeSearchParts: {
    searchParts1: '配件图号',
    searchParts2: '配件名称',
    searchParts3: '父件图号',
    searchParts4: '数量',
    searchParts5: '实物图片',
    searchParts6: '工时代码',
    searchParts7: '工时',
    searchParts8: '拆解步骤',
    searchParts9: '工具',
    searchParts10: '所属系统编码',
    searchParts11: '所属系统名称',
    searchParts12: '所属车型',
    searchParts13: '装车数量',
    searchParts14: '备注',
    searchParts15: '车型',
    searchParts16: '年款',
    searchParts17: '配置',
    searchParts18: '选装包类型',
    searchParts19: '电池类型',
    searchParts20: '里程',
    searchParts21: '型式认证号',
    searchParts22: '款型',
    searchParts23: '版本',
    searchParts24: '维修项目',
    searchParts25: '所属子系统名称',
    searchParts26: '单车用量',
    searchParts27: '历史装车用量',
    searchParts28: '父件号',
    searchParts29: '父件名称',
    searchParts30: '通用',
    searchParts31: '详情',
    searchParts32: '加入购物车',
    searchParts33: '是否可销售',
    searchParts34: '适用车型'
},
  technical: {
    technical1: '系统概述',
    technical2: '维修工具',
    technical3: '系统工作原理',
    technical4: '系统零部件位置及功能',
    technical5: '故障诊断',
    technical6: '专用工具',
    technical7: '常见故障',
    technical8: '维修指导',
    technical9: '工时工位',
    technical10: '注意事项',
    technical11: '技术参数',
    technical12: '编号',
    technical13: '目录名称',
    technical14: '配置信息',
    technical15: '查看',
    technical16: '名称',
    technical17: '图册名称',
    technical18: '图册版本',
    technical19: '配置',
    technical20: '生效时间',
    technical21: '失效时间',
    technical22: '没有该图册',
    technical23: '拆装步骤',
    technical24: '子工时'
  },
  routeRepair: {
    routeRepair1: '配件图册',
    routeRepair2: '维修手册',
    routeRepair3: '配件详情',
    routeRepair4: '配件编码',
    routeRepair5: '价格',
    routeRepair6: '配件名称',
    routeRepair7: '门店库存',
    routeRepair8: '最小包装数',
    routeRepair9: '总库存',
    routeRepair10: '购买',
    routeRepair11: '替换关系',
    routeRepair12: '变更前件号',
    routeRepair13: '变更后件号',
    routeRepair14: '替换类型',
    routeRepair15: '断点时间',
    routeRepair16: '断点VIN',
    routeRepair17: '替换备注',
    routeRepair18: '质量关键件',
    routeRepair19: 'SBOM属性备注',
    routeRepair20: '二轨信息',
    routeRepair21: '配置串适配性说明(包含左右舵)',
    routeRepair22: '技术状态'
  },
  routeCircuit: {
    routeCircuit1: '电路图信息',
    routeCircuit2: '电路图导读',
    routeCircuit3: '保险丝与继电器',
    routeCircuit4: '电源分配',
    routeCircuit5: '接地点分配',
    routeCircuit6: '线束布置图',
    routeCircuit7: '接插件端子定义',
    routeCircuit8: '对插件位置图',
    routeCircuit9: '对接插件',
    routeCircuit10: '线束结构图',
    routeCircuit11: '接地位置图',
    routeCircuit12: '全屏浏览'
  },
  sysUserList: {
    buildType: '用户类型',
    enterpriseType: '企业信息',
    roleName: '角色',
    code: '账号',
    state: '状态',
    job: '岗位',
    userName: '用户姓名',
    sex: '性别',
    phone: '手机号码'
  },
  sysRole: {
    routeSysRole1: '角色名称',
    routeSysRole2: '角色编码',
    routeSysRole3: '门店编码',
    routeSysRole4: '角色备注',
    routeSysRole5: '电话/邮箱',
    routeSysRole6: '创建时间',
    routeSysRole7: '有效期',
    routeSysRole8: '状态',
    routeSysRole9: '修改系统角色'
  },
  sysMenu: {
    routeSysMenu1: '折叠/展开',
    routeSysMenu2: '菜单名称',
    routeSysMenu3: '菜单类型',
    routeSysMenu4: '菜单编码',
    routeSysMenu5: '菜单路径',
    routeSysMenu6: '排序',
    routeSysMenu7: '菜单图标',
    routeSysMenu8: '父级菜单'
  },
  sysEnterprise: {
    sysEnterprise1: '企业类型',
    sysEnterprise2: '品牌',
    sysEnterprise3: '企业编码',
    sysEnterprise4: '企业名称',
    sysEnterprise5: '企业地址',
    sysEnterprise6: '联系人姓名',
    sysEnterprise7: '联系人电话',
    sysEnterprise8: '联系人Email',
    sysEnterprise9: '修改时间',
    sysEnterprise10: '修改人',
    sysEnterprise11: '区域类型',
    sysEnterprise12: '售后区域',
    sysEnterprise13: '请选择区域类型',
    sysEnterprise14: '省',
    sysEnterprise15: '市',
    sysEnterprise16: '经销品牌',
    sysEnterprise17: '创建时间'
  },
  sysChange: {
    sysChange1: '车型',
    sysChange2: '变更ECN/EWO名称',
    sysChange3: 'EWO名称',
    sysChange4: '切换方式',
    sysChange5: '变更下发时间',
    sysChange6: '变更接收时间',
    sysChange7: 'SPA是否更改',
    sysChange8: '现场执行情况',
    sysChange9: '是否试装',
    sysChange10: '试装结论',
    sysChange11: '变更阶段',
    sysChange12: '是否收到切换',
    sysChange13: 'MWO编号',
    sysChange14: 'MWO生效时间',
    sysChange15: '断点VIN码'
  },
  notice: {
    notice1: '车型',
    notice2: '模块分组',
    notice3: '零件名称',
    notice4: '内容',
    notice5: '更多',
    notice6: '系统',
    notice7: '主因零部件',
    notice8: '故障现象',
    notice9: '可能原因',
    notice10: '活动类型',
    notice11: '活动编号',
    notice12: '活动名称',
    notice13: '检索内容',
    notice14: '维修措施',
    notice15: '公告',
    notice16: '发布日期',
    notice17: '发布时间',
    notice18: '发布人',
    notice19: '子系统',
    notice20: '创建日期',
    notice21: '创建人',
    notice22: '整车编码',
    notice23: '零件编码',
    notice24: '工厂',
    notice25: '用量',
    notice26: '电池一车一BOM',
    notice27: '车辆VIN',
    notice28: '编码',
    notice29: '类别',
    notice30: '电驱BOM',
    notice31: 'SN码',
    notice32: '物料号',
    notice33: '物料名',
    notice34: '工单号',
    notice35: 'BOM物料号',
    notice36: 'BOM物料名',
    notice37: '关联控制器SN',
    notice38: '关联控制器物料号',
    notice39: '关联控制器物料名',
    notice40: '控制器工单号',
    notice41: '发送时间',
    notice42: '发送人',
    notice43: '发送信息',
    addDirectory: '目录管理',
    addText: '新增文本',
    keyword: '关键字',
    keywordPlaceholder: '请输入关键字',
    directoryCategory: '目录分类',
    directoryTitle: '文本标题',
    selectDirectoryCategory: '请选择目录分类',
    inputDirectoryTitle: '请输入文本标题',
    inputContent: '请输入内容',
    directoryName: '目录名称',
    inputDirectoryName: '请输入目录名称',
    cancelPublish: '撤销发布',
    unpublished: '未发布',
    published: '已发布',
    confirmCancel: '确认要撤销发布吗？',
    confirmMigrate: '是否将该文本迁移到新的目录分类？',
    directoryManage: '目录管理'
  },
  overseas: {
    overseas1: '组织代码',
    overseas2: '组织名称',
    overseas3: '海外权限',
    overseas4: '是否VIN可查看',
    overseas5: '中文名称',
    overseas6: '是否已翻译',
    overseas7: '英文名称',
    overseas8: '推送模块',
    overseas9: '详细信息',
    overseas10: '邮箱',
    overseas11: '下载模版',
    overseas12: '保存失败',
    overseas13: '需保留最后一条数据',
    overseas14: '备件公告',
    overseas15: '知识库',
    overseas16: '市场处置',
    overseas17: '技术通告',
    overseas18: '维修案例',
    overseas19: '新增邮箱'
  },
  iccId: {
    IoTNetworkCardICCID: '物联网卡ICCID',
    updateTime: '更新时间'
  },
  zip: {
    export: '导出',
    import: '导入',
    uploadAttach: '上传附件',
    enclosure: '附件',
    enclosure1: '反馈附件',
    placeholder: '请输入文件名(默认file)',
    success: '提交成功',
    update: '修改成功',
    add: '新增信息',
    modify: '修改信息',
    details: '查看详情',
    required: '还有必填项没填写'
  },
  message: {
    selectVehicleType: '请选择车型',
    selectTypeApprovalNumber: '请选择型式认证号',
    selectVersion: '请选择版本',
    syncSuccess: '同步成功',
    selectPartDrawingOrPartName: '请输入配件图号或配件名称',
    selectVehYearModel: '请选择年款',
    selectOptRange: '请选择里程',
    selectOptPower: '请选择配置',
    selectBatteryCore: '请选择电池类型',
    selectType: '请选择款型',
    noSyncAgainFor5Minutes: '5分钟内不能再次同步',
    browserCanNotWork: 'you browser can not work',
    switchSizeSuccess: 'Switch Size Success',
    compilingTheTheme: 'Compiling the theme',
    copySuccessfully: '复制成功',
    copyFailed: '复制失败',
    orderGenerated: '已生成订单',
    selectOrderWantToGenerated: '请选择要生成的订单',
    successfullyDelete: '删除成功',
    enterYourVIN: '请输入vin号',
    length17: '长度17个字符',
    enterSubject: '请输入主题',
    enterProblemDescription: '请输入问题描述',
    enterPersonAskingTheQuestion: '请输入提问人',
    enterContactPhone: '请输入联系电话',
    wrongNumber: '手机号格式错误',
    uploadAttachment: '请上传附件',
    uploadSuccess: '上传成功',
    orderGeneratedSuccess: '订单生成成功',
    selectOrderToSend: '请选择要发送的订单',
    replySuccess: '回复成功',
    fillInSolutionReason: '请填写解决原因',
    selectCarSeries: '请选择车系',
    selectQuestionCategory: '请选择问题分类',
    selectGroup: '请选择分组',
    enterQueryTime: '请输入查询时间',
    addedToCart: '已加入购物车',
    selectQueryCriteria: '请选择查询条件',
    selectPublish: '请选择发布内容',
    cancelRelease: '取消发布!',
    selectContent: '请选择撤销内容',
    operateSuccess: '操作成功',
    selectNeedToDelete: '请选择要删除的内容',
    successfullyAdded: '添加成功',
    selectSystem: '请选择所属系统',
    selectVINOrVehicleNavigation: '请选择VIN查询或车型导航查询',
    canceled: '已取消',
    mustBeNumericValue: '必须为数字值',
    queryNumber: '请输入查询编号',
    regionCode: '请输入区域编码',
    regionName: '请输入区域名称',
    provinceOrMunicipalityCode: '请选择输入省/直辖市编码',
    provinceOrMunicipality: '请选择输入省/直辖市',
    cityCode: '请选择输入城市编码',
    city: '请选择输入城市',
    areaInformationDetails: '区域信息详情',
    newAreaInformation: '新增区域信息',
    modifyingRegionInformation: '修改区域信息',
    enterpriseInformationSuccessfully: '保存企业信息成功',
    modifiedRegionInformationSuccessfully: '修改区域信息成功',
    companyName: '请输入企业名称',
    companyCode: '请输入企业编号',
    length11: '长度11个字符',
    companyType: '请选择企业类型',
    selectState: '请选择状态',
    length100: '长度100个字符',
    newCompany: '新增企业信息',
    updateCompany: '修改企业信息',
    saveSystemUserSuccessfully: '保存系统用户成功',
    updateCompanySuccess: '修改企业成功',
    menuName: '请输入菜单名称',
    menuCode: '请输入菜单编码',
    menuUrl: '请输入菜单路径',
    menuType: '请选择菜单类型',
    length2To10: '长度在 2 到 10 个字符',
    length4To50: '长度在 4 到 50 个字符',
    length4To100: '长度在 4 到 100 个字符',
    menuDetail: '系统菜单详情',
    addMenu: '新增系统菜单',
    updateMenu: '修改系统菜单',
    saveMenuSuccess: '保存系统菜单成功',
    updateMenuSuccess: '修改系统菜单成功',
    saveSuccess: '保存成功',
    enterRoleName: '请输入角色名称',
    enterRoleCode: '请输入角色编码',
    length4To20: '长度在 4 到 20 个字符',
    newRole: '新增系统角色',
    updateRole: '修改系统角色',
    saveRoleSuccess: '保存系统角色成功',
    updateRoleSuccess: '修改系统角色成功',
    uploadError: '上传错误',
    selectFile: '请选择文件',
    uploadedAvatarSuccess: '上传头像成功',
    resetPasswordSuccess: '重置密码成功',
    enterAccount: '请输入用户账号',
    enterUserName: '请输入用户名称',
    selectCompany: '请选择企业',
    selectRole: '请选择角色',
    selectPosition: '请选择岗位',
    userDetail: '系统用户详情',
    addUser: '新增系统用户',
    updateUser: '修改系统用户',
    updateUserSuccess: '修改系统用户成功',
    undeleted: '已取消删除',
    selectAttachments: '请选择附件',
    ctrlVCopy: '点击此处 将图片按Ctrl+V 粘贴至此处'
  },
  partAdviceListStatusEnum: {
    0: '已提交',
    1: '已回复',
    2: '已解决'
  },
  feedBackStatusEnum: {
    0: '未发布',
    1: '未发布',
    2: '已发布'
  },
  auditStatusEnum: {
    0: '待审核',
    1: '已通过',
    2: '被驳回'
  },
  knowledgeStatusEnum: {
    0: '未发布',
    1: '已发布'
  },
  frequencyOfFailuresEnum: {
    0: '偶发',
    1: '持续',
    2: '其他'
  },
  dialog: {
    publish: '发布',
    publishTo: '发布到',
    cancel: '取 消',
    confirm: '确 定'
  },
  sysMember: {
    memberUser: '会员用户',
    registeredUser: '注册用户',
    username: '用户名',
    phone: '手机号',
    memberType: '会员类型',
    validPeriod: '有效期',
    name: '姓名',
    registerDate: '注册日期',
    dayMember: '日会员',
    monthMember: '月会员',
    quarterMember: '季度会员',
    yearMember: '年会员',
    buy: '购买',
    extend: '延期',
    viewDetail: '查看详情',
    buyTitle: '购买',
    extendTitle: '延期',
    detailTitle: '查看详情',
    purchaseProduct: '购买产品',
    purchaseType: '购买类型',
    transactionAmount: '交易金额(元)',
    confirmFreeze: '确认冻结该会员?',
    freezeSuccess: '冻结成功',
    freezeFail: '冻结失败',
    buySuccess: '购买成功',
    buyFail: '购买失败',
    extendSuccess: '延期成功',
    extendFail: '延期失败',
    freeze: '冻结',
    transactionDate: '交易日期'
  }
}
